/* KP theme scripts: bundle picker, review pages, testimonial carousel,
   phone gallery dots, cart reservation timer, back-to-top button. */
(function () {
  'use strict';

  /* ---------- Bundle picker ---------- */
  if (!customElements.get('kp-bundles')) {
    class KpBundles extends HTMLElement {
      connectedCallback() {
        this.offers = Array.from(this.querySelectorAll('.kp-bundle'));
        this.offers.forEach((offer) => {
          const input = offer.querySelector('.kp-bundle__input');
          input.addEventListener('change', () => this.select(offer));
          offer.querySelectorAll('.kp-bundle__select').forEach((select) => {
            // Keep clicks on the colour menus from re-toggling the label
            select.addEventListener('click', (e) => e.stopPropagation());
            select.addEventListener('change', () => this.updateImage(select));
          });
        });
        const productEl = this.closest('.kp-product');
        if (productEl) productEl.classList.add('kp-has-bundles');

        this.onSubmit = this.onSubmit.bind(this);
        document.addEventListener('submit', this.onSubmit, true);
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this.onSubmit, true);
      }

      select(offer) {
        this.offers.forEach((o) => o.classList.toggle('is-selected', o === offer));
      }

      updateImage(select) {
        const option = select.options[select.selectedIndex];
        const img = select.parentElement.querySelector('.kp-bundle__variant-img');
        if (img && option && option.dataset.img) {
          img.src = option.dataset.img;
          img.removeAttribute('srcset');
        }
      }

      selectedOffer() {
        return this.offers.find((o) => o.querySelector('.kp-bundle__input').checked) || this.offers[0];
      }

      buildItems() {
        const offer = this.selectedOffer();
        if (!offer) return null;
        if (offer.dataset.variantId) {
          const items = [{ id: Number(offer.dataset.variantId), quantity: 1 }];
          if (this.dataset.giftId) items.push({ id: Number(this.dataset.giftId), quantity: 1 });
          return items;
        }
        const count = parseInt(offer.dataset.items, 10) || 1;
        const totals = new Map();
        const selects = offer.querySelectorAll('.kp-bundle__select');
        if (selects.length) {
          selects.forEach((s) => totals.set(s.value, (totals.get(s.value) || 0) + 1));
        } else {
          const form = document.getElementById(this.dataset.formId);
          const idInput = form && form.querySelector('[name="id"]');
          if (!idInput) return null;
          totals.set(idInput.value, count);
        }
        const items = Array.from(totals, ([id, quantity]) => ({ id: Number(id), quantity }));
        if (this.dataset.giftId) items.push({ id: Number(this.dataset.giftId), quantity: 1 });
        return items;
      }

      onSubmit(evt) {
        const form = evt.target;
        if (!form || form.getAttribute('id') !== this.dataset.formId) return;
        const items = this.buildItems();
        if (!items) return;
        evt.preventDefault();
        evt.stopPropagation();

        const productForm = form.closest('product-form');
        const button = form.querySelector('[type="submit"]');
        if (button && button.getAttribute('aria-disabled') === 'true') return;
        const spinner = productForm && productForm.querySelector('.loading__spinner');
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        if (button) {
          button.setAttribute('aria-disabled', true);
          button.classList.add('loading');
        }
        if (spinner) spinner.classList.remove('hidden');

        const body = { items };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement(document.activeElement);
        }

        fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((response) => {
            if (response.status) {
              if (productForm && productForm.handleErrorMessage) {
                productForm.handleErrorMessage(response.description || response.message);
              }
              return;
            }
            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }
            response.id = Number(this.dataset.productId);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id, cartData: response });
            }
            cart.renderContents(response);
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          })
          .catch((e) => console.error(e))
          .finally(() => {
            if (button) {
              button.classList.remove('loading');
              button.removeAttribute('aria-disabled');
            }
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
    customElements.define('kp-bundles', KpBundles);
  }

  /* ---------- Video row: tap to open full size ---------- */
  if (!customElements.get('kp-videos')) {
    class KpVideos extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('button.kp-videos__item'));
        this.items.forEach((item, i) => item.addEventListener('click', () => this.open(i)));
      }

      modal() {
        let m = document.getElementById('KpVideoModal');
        if (m) return m;
        m = document.createElement('div');
        m.id = 'KpVideoModal';
        m.className = 'kp-video-modal';
        m.hidden = true;
        m.setAttribute('role', 'dialog');
        m.setAttribute('aria-modal', 'true');
        m.innerHTML =
          '<div class="kp-video-modal__box">' +
          '<button type="button" class="kp-video-modal__close" aria-label="Close">&times;</button>' +
          '<button type="button" class="kp-video-modal__nav kp-video-modal__nav--prev" aria-label="Previous video">&#8249;</button>' +
          '<button type="button" class="kp-video-modal__nav kp-video-modal__nav--next" aria-label="Next video">&#8250;</button>' +
          '<video controls playsinline autoplay></video></div>';
        document.body.appendChild(m);
        m.addEventListener('click', (e) => {
          if (e.target === m) this.close();
        });
        m.querySelector('.kp-video-modal__close').addEventListener('click', () => this.close());
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && !m.hidden) this.close();
        });
        return m;
      }

      open(i) {
        const m = this.modal();
        this.index = (i + this.items.length) % this.items.length;
        const src = this.items[this.index].querySelector('video');
        const video = m.querySelector('video');
        video.innerHTML = src.innerHTML;
        video.poster = src.poster;
        video.muted = false;
        video.load();
        video.play().catch(() => {});
        const prev = m.querySelector('.kp-video-modal__nav--prev');
        const next = m.querySelector('.kp-video-modal__nav--next');
        prev.hidden = next.hidden = this.items.length < 2;
        prev.onclick = () => this.open(this.index - 1);
        next.onclick = () => this.open(this.index + 1);
        m.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      close() {
        const m = document.getElementById('KpVideoModal');
        if (!m) return;
        const video = m.querySelector('video');
        video.pause();
        m.hidden = true;
        document.body.style.overflow = '';
      }
    }
    customElements.define('kp-videos', KpVideos);
  }

  /* ---------- Verified reviews pagination ---------- */
  if (!customElements.get('kp-reviews')) {
    class KpReviews extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.kp-review'));
        this.nav = this.querySelector('.kp-pagination');
        this.page = 0;
        this.mq = window.matchMedia('(max-width: 749px)');
        this.render = this.render.bind(this);
        this.mq.addEventListener('change', () => {
          this.page = 0;
          this.render();
        });
        this.render();
      }

      perPage() {
        const d = parseInt(this.dataset.perPage, 10) || 12;
        const m = parseInt(this.dataset.perPageMobile, 10) || 6;
        return this.mq.matches ? m : d;
      }

      render() {
        const per = this.perPage();
        const pages = Math.max(1, Math.ceil(this.cards.length / per));
        if (this.page >= pages) this.page = pages - 1;
        this.cards.forEach((c, i) => {
          c.hidden = Math.floor(i / per) !== this.page;
        });
        if (!this.nav) return;
        this.nav.innerHTML = '';
        if (pages < 2) return;
        for (let p = 0; p < pages; p++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.textContent = p + 1;
          b.setAttribute('aria-label', `Page ${p + 1}`);
          if (p === this.page) {
            b.classList.add('is-active');
            b.setAttribute('aria-current', 'page');
          }
          b.addEventListener('click', () => {
            this.page = p;
            this.render();
            const top = this.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top, behavior: 'smooth' });
          });
          this.nav.appendChild(b);
        }
      }
    }
    customElements.define('kp-reviews', KpReviews);
  }

  /* ---------- Carousel (testimonials) ---------- */
  if (!customElements.get('kp-carousel')) {
    class KpCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.kp-testi__track');
        this.slides = Array.from(this.querySelectorAll('.kp-testi__slide'));
        this.prev = this.querySelector('.kp-arrow--prev');
        this.next = this.querySelector('.kp-arrow--next');
        this.dots = this.querySelector('.kp-dots');
        if (!this.track || !this.slides.length) return;
        this.prev && this.prev.addEventListener('click', () => this.go(this.index() - 1));
        this.next && this.next.addEventListener('click', () => this.go(this.index() + 1));
        this.track.addEventListener('scroll', () => window.requestAnimationFrame(() => this.update()), {
          passive: true,
        });
        window.addEventListener('resize', () => this.buildDots());
        this.buildDots();
      }

      step() {
        const s = this.slides[1] || this.slides[0];
        return s.offsetLeft - this.slides[0].offsetLeft || this.track.clientWidth;
      }

      visible() {
        return Math.max(1, Math.round(this.track.clientWidth / this.step()));
      }

      maxIndex() {
        return Math.max(0, this.slides.length - this.visible());
      }

      index() {
        return Math.round(this.track.scrollLeft / this.step());
      }

      go(i) {
        const target = Math.max(0, Math.min(i, this.maxIndex()));
        this.track.scrollTo({ left: target * this.step(), behavior: 'smooth' });
      }

      buildDots() {
        if (!this.dots) return;
        this.dots.innerHTML = '';
        const count = this.maxIndex() + 1;
        if (count < 2) {
          this.update();
          return;
        }
        for (let i = 0; i < count; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', `Slide ${i + 1}`);
          b.addEventListener('click', () => this.go(i));
          this.dots.appendChild(b);
        }
        this.update();
      }

      update() {
        const i = this.index();
        if (this.prev) this.prev.disabled = i <= 0;
        if (this.next) this.next.disabled = i >= this.maxIndex();
        if (this.dots) {
          Array.from(this.dots.children).forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
        }
      }
    }
    customElements.define('kp-carousel', KpCarousel);
  }

  /* ---------- Phone gallery dots (product page) ---------- */
  function initGalleryDots() {
    document.querySelectorAll('.kp-product media-gallery').forEach((gallery) => {
      if (gallery.querySelector('.kp-gallery-dots')) return;
      const list = gallery.querySelector('[id^="Slider-Gallery"]');
      if (!list) return;
      const items = Array.from(list.querySelectorAll('.product__media-item'));
      if (items.length < 2) return;
      const dots = document.createElement('div');
      dots.className = 'kp-gallery-dots';
      items.forEach((item, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `Image ${i + 1}`);
        b.addEventListener('click', () => list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: 'smooth' }));
        dots.appendChild(b);
      });
      const slider = list.closest('slider-component') || list.parentElement;
      slider.insertAdjacentElement('afterend', dots);
      const update = () => {
        const w = items[0].offsetWidth || 1;
        const i = Math.round(list.scrollLeft / w);
        Array.from(dots.children).forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
      };
      list.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      update();
    });
  }

  /* ---------- Cart reservation timer ---------- */
  function initCartTimer() {
    const KEY = 'kp-cart-timer-end';
    const tick = () => {
      const els = document.querySelectorAll('[data-kp-timer]');
      if (!els.length) return;
      const minutes = parseInt(els[0].dataset.kpTimer, 10) || 10;
      let end = 0;
      try {
        end = parseInt(sessionStorage.getItem(KEY), 10) || 0;
      } catch (e) {}
      const now = Date.now();
      if (!end || end < now) {
        end = now + minutes * 60000;
        try {
          sessionStorage.setItem(KEY, String(end));
        } catch (e) {}
      }
      const left = Math.max(0, Math.round((end - now) / 1000));
      const text = `${String(Math.floor(left / 60)).padStart(2, '0')}:${String(left % 60).padStart(2, '0')}`;
      els.forEach((el) => {
        const out = el.querySelector('[data-kp-timer-value]');
        if (out) out.textContent = text;
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Back to top ---------- */
  function initToTop() {
    const btn = document.querySelector('.kp-to-top');
    if (!btn) return;
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    const onScroll = () => btn.classList.toggle('is-visible', window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    initGalleryDots();
    initCartTimer();
    initToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', initGalleryDots);
})();
